exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button .zb-spin[data-v-77c46844]{display:none}button.loading .zb-spin[data-v-77c46844]{display:inline-block}.font-bry[data-v-77c46844]{font-family:Brygada\\ 1918,serif}", ""]);

// exports
